import './helpers/instrument';
import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Provider as ThemeProvider, theme30 } from '@mos-cat/ds-theme';
import '@mos-cat/ds-theme/reset.css';

import App from './App';

/**
 * @param {Function} fn
 */
const ready = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

ready(() => {
  const widgetNode = document.querySelector('[data-widget="widget-hotwater-modern"]');
  if (widgetNode) {
    ReactDOM.render<ReactNode>(
      // @ts-ignore
      <Sentry.ErrorBoundary>
        <ThemeProvider theme={theme30}>
          <App />
        </ThemeProvider>
      </Sentry.ErrorBoundary>,
      widgetNode,
    );
  }
});
